import React, {memo} from "react";
import styled from "styled-components";
import OrderedUsersListItem from "../ListItemsComponents/OrderedUsersListItem"
import {nanoid} from "nanoid"


const OrderedUsersList = ({usersList}) => usersList?.length > 0 && usersList.map(el => <OrderedUsersListItem key={nanoid()} data={el}/>)

export default memo(OrderedUsersList);
